// Cookie 工具函数

// 设置 Cookie
export function setCookie(name, value, options = {}) {
  let cookieString = `${name}=${encodeURIComponent(value)}`;

  // 根据当前域名自动判断 cookie domain
  // 在 fapi.uk 域名（含子域名）下使用 .fapi.uk 实现跨子域共享
  // 在 localhost 或其他域名下不设置 domain，使用浏览器默认行为
  const hostname = window.location.hostname;
  const isOnFapiDomain = hostname === 'fapi.uk' || hostname.endsWith('.fapi.uk');

  // 默认选项
  const defaultOptions = {
    domain: isOnFapiDomain ? '.fapi.uk' : '',
    path: '/',
    httpOnly: false, // 前端设置的 cookie 无法设置 httpOnly: true，这个需要后端配合
    secure: window.location.protocol === 'https:',
    sameSite: 'lax',
    maxAge: 60 * 24 * 60 * 60 * 1000 // 60天
  };

  const finalOptions = { ...defaultOptions, ...options };

  // 添加选项到 cookie 字符串
  if (finalOptions.domain) {
    cookieString += `; domain=${finalOptions.domain}`;
  }
  if (finalOptions.path) {
    cookieString += `; path=${finalOptions.path}`;
  }
  if (finalOptions.secure) {
    cookieString += '; secure';
  }
  if (finalOptions.sameSite) {
    cookieString += `; samesite=${finalOptions.sameSite}`;
  }
  if (finalOptions.maxAge) {
    cookieString += `; max-age=${Math.floor(finalOptions.maxAge / 1000)}`;
  }
  if (finalOptions.expires) {
    cookieString += `; expires=${finalOptions.expires.toUTCString()}`;
  }

  document.cookie = cookieString;
}

// 获取 Cookie
export function getCookie(name) {
  const cookieName = `${name}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');

  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i].trim();
    if (cookie.indexOf(cookieName) === 0) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }

  return null;
}

// 删除 Cookie
export function deleteCookie(name, options = {}) {
  const hostname = window.location.hostname;
  const isOnFapiDomain = hostname === 'fapi.uk' || hostname.endsWith('.fapi.uk');

  const defaultOptions = {
    domain: isOnFapiDomain ? '.fapi.uk' : '',
    path: '/'
  };

  const finalOptions = { ...defaultOptions, ...options };

  // 设置过期时间为过去，实现删除
  setCookie(name, '', {
    ...finalOptions,
    maxAge: -1
  });
}

// 从 localStorage 迁移数据到 cookie
export function migrateLocalStorageToCookie() {
  // 检查是否已经迁移过
  const hasMigrated = getCookie('migratedFromLocalStorage');
  if (hasMigrated) {
    return;
  }

  // 迁移 token
  const token = localStorage.getItem('token');
  if (token) {
    setCookie('token', token);
  }

  // 迁移 userInfo
  const userInfo = localStorage.getItem('userInfo');
  if (userInfo) {
    setCookie('userInfo', userInfo);
  }

  // 迁移 isLogin
  const isLogin = localStorage.getItem('isLogin');
  if (isLogin) {
    setCookie('isLogin', isLogin);
  }

  // 迁移 chainId
  const chainId = localStorage.getItem('chainId');
  if (chainId) {
    setCookie('chainId', chainId);
  }

  // 迁移 address
  const address = localStorage.getItem('address');
  if (address) {
    setCookie('address', address);
  }

  // 迁移 apiKey
  const apiKey = localStorage.getItem('apiKey');
  if (apiKey) {
    setCookie('apiKey', apiKey);
  }

  // 设置迁移标记
  setCookie('migratedFromLocalStorage', 'true', { maxAge: 60 * 24 * 60 * 60 * 1000 }); // 60天过期
}
